import React, { PureComponent } from 'react';

export default class Dots extends PureComponent {
    render() {
        const { selectedDatapoint } = this.props;
        const { pointStyle, pointRadius, color, data } = this.props.data;

        const defineDots = (datum) => {
            const d = Array.isArray(datum) ? data : datum;
            if (isNaN(parseInt(d.y))) return null; // No point/hover for null data
            const x = this.props.x(d.x);
            const y = this.props.y(d.y);

            const dataPoint = { ...d, xpos: x, ypos: y };
            switch (pointStyle) {
                case 'star': {
                    const rads = (144 * Math.PI) / 180;
                    const points = [[x, y - pointRadius]]; // the tip left of the top tip
                    let angle = -rads * 3; // the angle coming out of the above point
                    for (let i = 0; i < 4; ++i) {
                        const x = points[i][0] + Math.cos(angle) * pointRadius * 2;
                        const y = points[i][1] + Math.sin(-angle) * pointRadius * 2;
                        points.push([x, y]);
                        angle = angle - rads;
                    }
                    const pointString = points.map((p) => p.join(',')).join(' ');
                    dataPoint.svg = <polygon className='dot star' points={pointString} fill={color} strokeWidth={pointRadius / 6} />;
                    return dataPoint;
                }
                case 'triangle': {
                    dataPoint.svg = (
                        <polygon
                            className='dot triangle'
                            points={`${x},${y - pointRadius} ${x + pointRadius * Math.sin(Math.PI / 3)},${y + pointRadius * 0.5} ${x - pointRadius * Math.sin(Math.PI / 3)},${
                                y + pointRadius * 0.5
                            }`}
                            fill={'#FFFFFF'}
                            stroke={color}
                            strokeWidth={pointRadius / 2}
                        />
                    );
                    return dataPoint;
                }
                case 'dash': {
                    dataPoint.svg = (
                        <line className='dot dash' x1={x - pointRadius} x2={x + pointRadius} y1={y} y2={y} stroke={color} strokeWidth={pointRadius / 2} />
                    );
                    return dataPoint;
                }
                case 'cross': {
                    dataPoint.svg = (
                        <g>
                            <line className='dot cross' x1={x - pointRadius} x2={x + pointRadius} y1={y} y2={y} stroke={color} strokeWidth={pointRadius / 2} />
                            <line className='dot cross' x1={x} x2={x} y1={y - pointRadius} y2={y + pointRadius} stroke={color} strokeWidth={pointRadius / 2} />
                        </g>
                    );
                    return dataPoint;
                }
                case 'crossRot': {
                    dataPoint.svg = (
                        <g transform={`rotate(45, ${x}, ${y})`}>
                            <line
                                className='dot crossRot'
                                x1={x - pointRadius}
                                x2={x + pointRadius}
                                y1={y}
                                y2={y}
                                stroke={color}
                                strokeWidth={pointRadius / 2}
                            />
                            <line
                                className='dot crossRot'
                                x1={x}
                                x2={x}
                                y1={y - pointRadius}
                                y2={y + pointRadius}
                                stroke={color}
                                strokeWidth={pointRadius / 2}
                            />
                        </g>
                    );
                    return dataPoint;
                }
                case 'rectRounded': {
                    dataPoint.svg = (
                        <rect
                            className='dot rectRounded'
                            width={pointRadius * 2}
                            height={pointRadius * 2}
                            x={x - pointRadius}
                            y={y - pointRadius}
                            rx={pointRadius / 2}
                            ry={pointRadius / 2}
                            fill={'#FFFFFF'}
                            stroke={color}
                            strokeWidth='1'
                        />
                    );
                    return dataPoint;
                }
                case 'rectRot': {
                    dataPoint.svg = (
                        <rect
                            className='dot rectRot'
                            width={pointRadius * 2}
                            height={pointRadius * 2}
                            x={x - pointRadius}
                            y={y - pointRadius}
                            transform={`rotate(45, ${x}, ${y})`}
                            fill={'#FFFFFF'}
                            stroke={color}
                            strokeWidth='1'
                        />
                    );
                    return dataPoint;
                }
                case 'rect': {
                    dataPoint.svg = (
                        <rect
                            className='dot rect'
                            width={pointRadius * 2}
                            height={pointRadius * 2}
                            x={x - pointRadius}
                            y={y - pointRadius}
                            fill={'#FFFFFF'}
                            stroke={color}
                            strokeWidth='1'
                        />
                    );
                    return dataPoint;
                }
                case 'none': {
                    dataPoint.svg = null;
                    return dataPoint;
                }
                case 'dot': {
                    dataPoint.svg = <circle className='dot circle' r={1.5} cx={x} cy={y} fill={color} stroke={color} />;
                    return dataPoint;
                }
                case 'circle':
                default: {
                    dataPoint.svg = <circle className='dot circle' r={pointRadius} cx={x} cy={y} fill={'#FFFFFF'} stroke={color} />;
                    return dataPoint;
                }
            }
        };

        const generateDots = (d, i) => {
            if (!d) return null;

            return (
                <g key={`${i} ${d.xpos} ${d.ypos}`}>
                    <g>{d.svg}</g>
                    {selectedDatapoint === i && (
                        <g>
                            <circle
                                r={6}
                                cx={d.xpos}
                                cy={d.ypos}
                                style={{
                                    stroke: color,
                                    strokeWidth: 1,
                                    fill: 'none',
                                    opacity: 1,
                                }}
                            />
                            <circle
                                r={3}
                                cx={d.xpos}
                                cy={d.ypos}
                                style={{
                                    fill: color,
                                    opacity: 1,
                                }}
                            />
                        </g>
                    )}
                </g>
            );
        };

        const dots = data
            .filter((d) => (Array.isArray(d) && d.length > 0) || !Array.isArray(d))
            .map((data) => {
                if (Array.isArray(data)) {
                    return data.map((datum) => defineDots(datum));
                } else {
                    return defineDots(data);
                }
            })
            .map((data, i) => {
                if (Array.isArray(data)) {
                    return data.map((datum, index) => generateDots(datum, index));
                } else {
                    return generateDots(data, i);
                }
            });
        return <g>{dots}</g>;
    }
}
